import styled from 'styled-components';

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  width: 15rem;
  min-height: 1px;
  flex: 1 0 auto;
  background: ${({ theme }) => theme.colors.lighterBackground};
  color: ${({ theme }) => theme.colors.gray[900]};
  box-shadow: 0 0.125rem 0.375rem 0 rgb(161 172 184 / 12%);

  @media(min-width: 1200px) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  @media(max-width: 1199px) {
    display: none !important;
  }
`;

export const OffcanvasStyle = styled.div`
  background: ${({ theme }) => theme.colors.lighterBackground};
`;

interface ILogoContainer {
  isLogoFull: boolean;
}

export const LogoContainer = styled.header<ILogoContainer>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ isLogoFull }) => isLogoFull ? '0rem 0rem 1rem' : '1rem'};
  width: 100%;

  img {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: ${({ isLogoFull }) => isLogoFull ? '100%' : '75%'};
    margin-left: ${({ isLogoFull }) => isLogoFull ? '0px' : '1em'};
  }
`;
